const parsePercent = (value: string): number => {
  return parseFloat(value?.replace(',', '.') || '0');
};

type DataForm = any; // se quiser, tipamos depois

type ValidateResult =
  | { valid: true }
  | {
      valid: false;
      tab?: string;
      field?: string;
      message: string;
    };

export const validateANP = (dataForm: DataForm): ValidateResult => {
  const cod_anp = dataForm.cod_anp?.value?.toString().substring(0, 9);

  if (
    cod_anp &&
    (cod_anp === '210203001' || cod_anp === '820101012') &&
    (!dataForm.des_unidade_tributavel ||
      dataForm.des_unidade_tributavel?.value === null ||
      dataForm.des_unidade_tributavel?.value === '')
  ) {
    return {
      valid: false,
      tab: 'interface',
      field: 'des_unidade_tributavel',
      message: 'Unidade Tributável deve ser informada.',
    };
  }

  if (cod_anp === '210203001') {
    const per_glp = parsePercent(dataForm.per_glp);
    const per_gnn = parsePercent(dataForm.per_gnn);
    const per_gni = parsePercent(dataForm.per_gni);
    const { val_partida } = dataForm;

    if (per_glp <= 0 && per_gnn <= 0 && per_gni <= 0) {
      return {
        valid: false,
        tab: 'interface',
        field: 'per_glp',
        message: '% do combustível deve ser informado.',
      };
    }

    if (per_glp + per_gnn + per_gni !== 100) {
      return {
        valid: false,
        tab: 'interface',
        field: 'per_glp',
        message: 'Soma dos percentuais (combustível) deve ser igual a 100%.',
      };
    }

    if (val_partida <= 0) {
      return {
        valid: false,
        tab: 'interface',
        field: 'val_partida',
        message: 'Valor de partida deve ser informado.',
      };
    }
  }

  return { valid: true };
};
